module.exports = __webpack_public_path__ + "static/media/Konstantin_Vaksin.e50ea669.jpg";